import { render, staticRenderFns } from "./ProductEditSidebar.vue?vue&type=template&id=1bb2ee20&scoped=true&"
import script from "./ProductEditSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditSidebar.vue?vue&type=style&index=0&id=1bb2ee20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2ee20",
  null
  
)

export default component.exports